import * as React from 'react';
import { createInheritedProvider } from '@shapeable/utils';
export var BlockLayoutsContext = React.createContext({});
export var BlockLayoutsProvider = createInheritedProvider(BlockLayoutsContext);
export var useBlockLayouts = function () {
  return React.useContext(BlockLayoutsContext);
};